import { connect } from 'react-redux'
import { actionCreators } from '../../state/actions/trips'
import { IStoreState, ITripFilters } from '../../types/index'
import BillingManagementPane from 'src/components/billing/management/BillingManagementPane'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingManagementPane)



// WEBPACK FOOTER //
// ./src/containers/trips/BillingManagementPane.ts